import React, {Component} from 'react'
import {BrowserRouter} from "react-router-dom";
import Router from './shared/NewRouter'
import {connect} from 'react-redux'

import './App.scss'

class App extends Component {

    state = {
        currentAppVersion: process.env.REACT_APP_APP_VERSION || 1,
    }

    constructor(props) {
        super(props)

        // Update store on theme settings change
        // themeSettings._themeSettings.settings.onSettingsChange = () =>
        //   this.props.updateThemeSettings()

        //default theme settinh
        //themeSettingsFooterBg footer-theme
        //themeSettingsTheme theme-cotton
        //themeSettingsSidenavBg dark
        //themeSettingsMaterial = false
        //themeSettingsNavbarBg = success
        // localStorage.setItem('themeSettingsFooterBg', 'footer-theme')
        // localStorage.setItem('themeSettingsTheme', 'theme-cotton')
        // localStorage.setItem('themeSettingsSidenavBg', 'dark')
        // localStorage.setItem('themeSettingsMaterial', 'false')
        // localStorage.setItem('themeSettingsNavbarBg', 'success')
    }

    componentDidMount() {
        console.log("this is login web")
    }

    componentDidUpdate() {

    }

    render() {
        return <BrowserRouter basename={process.env.REACT_APP_BASENAME}>
             <Router/>
        </BrowserRouter>
    }

}


export default connect(store => ({
    // user: store.authen.user ? store.authen.user : undefined,
}), {})(App)
